export const FIELDOFFICER_PERSONAL_DATA_ADD_INPUTLIST = "FIELDOFFICER_PERSONAL_DATA_ADD_INPUTLIST";
export const SELECTED_LEVEL1_LIST = "SELECTED_LEVEL1_LIST";
